import { useQuery } from '@tanstack/react-query';

import { getCoreVersionInfo } from '@/lib/api/core';
import { isBackendUnreachable } from '@/lib/utils/version-display';

export function useBackendFrontendVersion() {
  return useQuery({
    queryKey: ['core-version-info', typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown'],
    queryFn: ({ signal }) => getCoreVersionInfo(signal),
    staleTime: 60 * 1000,
    retry: 1,
    // Poll every 5s while the backend appears unreachable so the
    // login screen auto-recovers when it comes back up. Otherwise
    // we hold the cached value and respect ``staleTime``.
    refetchInterval: (query) =>
      isBackendUnreachable(query.state.data, query.state.status === 'error') ? 5000 : false,
  });
}

